import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { acceptOrRejectBlog, createBlog, deleteBlog, editBlog, getBlogById, getBlogs, updateBlogStatus } from '../api/blog';

export const useGetBlogs = (userType) => {
    return useQuery({
        queryKey: ['blogs', userType],
        queryFn: () => getBlogs(userType),
    });
}

export const useCreateBlog = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createBlog'],
        mutationFn: ({ data, coverImage, featuredImages, galleryImages }) =>
            createBlog(data, coverImage, featuredImages, galleryImages),
        onSuccess: () => {
            queryClient.invalidateQueries(['blogs']);
        },
    });
}

export const useEditBlog = (id) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['editBlog'],
        mutationFn: ({ data, coverImage, featuredImages, galleryImages }) =>
            editBlog(id, data, coverImage, featuredImages, galleryImages),
        onSuccess: () => {
            queryClient.invalidateQueries(['blogs']);
        },
    });
}

export const useGetBlogsById = (id) => {
    return useQuery({
        queryKey: ['blog', id],
        queryFn: () => getBlogById(id),
        enabled: !!id,
    });
}

export const useUpdateBlogStatus = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateBlogStatus'],
        mutationFn: (data) => updateBlogStatus(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['blogs']);
        },
    });
}

export const useAcceptOrRejectBlog = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['accept-reject'],
        mutationFn: (data) => acceptOrRejectBlog(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['blogs']);
        },
    });
}

export const useDeleteBlog = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteBlog'],
        mutationFn: (id) => deleteBlog(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['blogs']);
        },
    });
}